import { SunIcon } from "@heroicons/react/24/outline";
import React from "react";
import Courses from "../Courses/Courses";



const Home = () => {
  return (
    <div>
     <Courses></Courses>
    </div>
  );
};

export default Home;
